/** Delay before revoking, matching the original inline implementation. */
const REVOKE_DELAY_MS = 100;

/**
 * Hand a Blob to the browser as a file download.
 *
 * Shared by every CSV export so the object-URL lifecycle lives in one place
 * rather than being re-inlined at each call site.
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Deferred: revoking synchronously can cancel the download in some browsers.
  setTimeout(() => window.URL.revokeObjectURL(url), REVOKE_DELAY_MS);
};

/**
 * The ingredients CSV's filename for one product, e.g.
 * "My Viome Toothpaste & Gel Ingredients.csv". The product is in the name so each
 * product's export is told apart in the member's Downloads, and a second
 * product's file is not saved as a "(1)" copy of the first. Characters a
 * filesystem rejects are dropped; with no usable product name it falls back to
 * the generic name.
 */
export const ingredientsCsvFilename = (productName?: string): string => {
  const product = (productName ?? '')
    .replace(/[\\/:*?"<>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return `My Viome ${product || 'Supplements'} Ingredients.csv`;
};
